import { render } from "./UnknownActivityBadge.vue?vue&type=template&id=30f79a55&scoped=true"
import script from "./UnknownActivityBadge.vue?vue&type=script&lang=js"
export * from "./UnknownActivityBadge.vue?vue&type=script&lang=js"

import "./UnknownActivityBadge.vue?vue&type=style&index=0&id=30f79a55&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-30f79a55"

export default script